import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import './css/GalleryComponent1.css';
import { SRLWrapper } from 'simple-react-lightbox';
import { GALLERY_DELETED, GALLERY_NOT_PUBLISHED, WAIT_IMAGES_TO_LOAD } from '../../../../catalog/Comments';
import PlaceholderComponent1 from '../../placeholderComponents/placeholderComponent1/PlaceholderComponent1';
import { context } from '../../../../globalState/GlobalState';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import Spinner1 from '../../spinners/spinner1/Spinner1';
import ShareComponent1 from '../../shareComponents/shareComponent1/ShareComponent1';
import { getGalleryShareTitle, getGalleryURL } from '../../../../catalog/Social';

const GalleryComponent1 = (props) => {
    const { id, title, photos, deleted, published, loadingSpinner } = props;
    const { globalState } = useContext(context);

    const options = {
        buttons: {
            showFullscreenButton: false,
            showDownloadButton: false,
            showAutoplayButton: false,
        },
        // thumbnails: {
        //     showThumbnails: false,
        // },
    };

    const placeholderGalleryContent = () => {
        if (deleted) {
            return (<PlaceholderComponent1 text={GALLERY_DELETED} />);
        } if (!published) {
            return (<PlaceholderComponent1 text={GALLERY_NOT_PUBLISHED} />);
        }
        return null;
    };

    const showGallery = () => {
        if (deleted) {
            return false;
        } if (!published) {
            return false;
        }
        return true;
    };

    return (
        <div className="gallery-component1-container-container x-center m-b-50px">
            <div className="gallery-component1-container box-shadow-black bg-white curve-border-40px x-center p-t-100px p-b-100px p-l-100px p-r-100px m-t-50px">
                <h1 className="gallery-component1-title font-size-4xl alegreya-font-family font-weight-800 text-left-align font-spacing-wider text-uppercase m-t-0 m-b-20px m-l-50px m-r-50px">{title}</h1>
                {loadingSpinner ? <Spinner1 color={globalState.websiteStyles.colors.primaryColor} /> : (
                    <>
                        {showGallery() ? (
                            <>
                                <ShareComponent1
                                    title="Gallery"
                                    url={getGalleryURL(globalState, id)}
                                    shareTitle={getGalleryShareTitle(title, globalState.teamAlias)}
                                    marginTop={0}
                                    marginBottom={50}
                                    mobileMarginBottom={50}
                                />
                                {photos.length >= 50 ? (<p className="p-t-20px p-b-20px p-l-20px p-r-20px font-size-xl m-t-0 m-b-0 font-weight-100 text-gray">{WAIT_IMAGES_TO_LOAD}</p>) : null}
                                <SRLWrapper options={options}>
                                    <div className="gallery-component1-img-container m-l-50px">
                                        {photos.map((photo) => {
                                            return (
                                                <a key={photo.id} className="m-t-0 m-b-0 m-l-0 m-r-0" href={photo.image}>
                                                    <img className="gallery-component1-img curve-border-10px m-l-5px m-r-5px m-t-3px m-b-3px" src={photo.image} alt={photo.title ? photo.title : title} />
                                                </a>
                                            );
                                        })}
                                    </div>
                                </SRLWrapper>
                                {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                                    <img src={globalState.logo.logo2} className="gallery-component1-icon m-t-50px m-b-0" alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
                                ) : null}
                            </>
                        ) : placeholderGalleryContent()}
                    </>
                )}
            </div>
        </div>
    );
};

GalleryComponent1.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    photos: PropTypes.array.isRequired,
    deleted: PropTypes.bool.isRequired,
    published: PropTypes.bool.isRequired,
    loadingSpinner: PropTypes.bool,
};

GalleryComponent1.defaultProps = {
    title: 'Gallery',
    loadingSpinner: false,
};

export default memo(GalleryComponent1);
